module.exports = __webpack_public_path__ + "img/pencil-icon.958e4d11.svg";